

import React, { memo } from 'react';

import { RUSH_EDIT } from '../../../../Addons/constants/addonsToBeApproved';
import AddonView from '../../AddonView/AddonView';











function CommonAddonView({
  addon,
  addonType,
  getFormattedAddon,
  isAddonDescriptionWrapped,
  onChangeAddonStatus,
  shouldShowActions = false,
  isNewDesign
}) {
  const createViewItem = () => {
    const formattedAddon = getFormattedAddon(addonType, { [addonType]: addon }, null);

    if (!formattedAddon) return null;

    const { icon, reviewLabel, label, addonStatus, value } = formattedAddon;

    return {
      iconName: icon,
      text: reviewLabel || label,
      price: addon.cost,
      subText: addon.name,
      addonType,
      addonStatus,
      value: addonType === RUSH_EDIT ? addonType : value,
      suffixDagger: addonType === RUSH_EDIT
    };
  };

  const viewItem = createViewItem();

  return viewItem &&
  <AddonView
    isDescriptionWrapped={isAddonDescriptionWrapped}
    onChangeAddonStatus={onChangeAddonStatus}
    shouldShowActions={shouldShowActions}
    isNewDesign={isNewDesign}
    {...viewItem} />;


}

export default memo(CommonAddonView);